// extracted by mini-css-extract-plugin
export default {"form":"Map-Team_form__v9QFB","formFooter":"Map-Team_formFooter__6y6aD"};